import React from "react";
import * as actions from './Actions';
import Service from '../../service/Service';
import ShareOptions from './ShareOptions';
const service = new Service();

export default function CommonSection ({section, sectionData, data, eleRef}){
    // console.log("section === ", section.data);
    return(
        <div>
            <div className="queBlock">
            {data && data.map((data, index)=>
                <div key={index} className="common-sect" id={`article-${data.articleId}`}>
                    <div className="left arti-image" onClick={(e) => actions.viewArticle(section, "2", data.articleId, data.articleUrl && data.articleUrl.replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/'), e)}>
                        {/* <a href={data.articleUrl}> */}
                        <img src={data.articleImage && data.articleImage.replace("http://", "https://").replace("jpg", "webp")} className="dev_art_img" onError={(e) => {e.target.src = 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-placeholder.png'}}/>
                        {/* </a> */}
                    </div>
                    <div className="left arti-details">
                        <div className="M15_42 common-title line-clamp" onClick={(e) => actions.viewArticle(section, "2", data.articleId, data.articleUrl && data.articleUrl.replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/'), e)}>{data.articleTitle}</div>
                        <div className="R14_75 common-desc">
                            <span className="line-clamp">{data.articleText}</span>
                            {/* <span className="R12_9e arti-read-more" onClick={(e) => actions.viewArticle(section, "2", data['articleId'], data['articleUrl'].replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/'))}>Read More</span> */}
                        </div>
                        <div className="arti-actions">
                            <div className="left view-action">
                                <span data-icon-font="$" className="left"></span>
                                <span className="action-text left">
                                    <span className="view-count">{data.viewCount}</span>
                                    {data.viewCount == 1 ?
                                    ' View' : ' Views'
                                    }
                                </span>
                            </div>
                            {/* { 
                                section == "dietPlan" ? */}
                                <div className="left view-action like-act">
                                    <span data-icon-font="T" className={data.isLiked ? 'left activelike' : 'left'} onClick={(e) => actions.likeArticle(section, data['articleId'], sectionData.type, eleRef, e)}></span>
                                    <span className="action-text left">
                                        <span className="like-count">{data.likeCount}</span> 
                                    {data.likeCount == 1 ?
                                    ' Like' : ' Likes'
                                    }
                                    </span>
                                </div> 
                                {/* : 
                                <div className="left view-action">
                                    <span data-icon-font="T" className="left" onClick={(e) => actions.likeArticle(data['articleId'], data['stageId'], e, data['likeCount'], data['viewCount'], data['articleTitle'])}></span>
                                    <span className="action-text left">Like</span>
                                </div>
                            } */}
                            {/* <div></div> */}
                            <div className="share-action" id={`share_${section}_${data.articleId}`} onClick={() => actions.shareOn(`${section}_${data.articleId}`)}>
                                <span className="share-ic share-click"><img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook-icon.png"
                                alt="Facebook" title="Facebook" /></span>
                                <span className="share-ic whtap-icon share-click" data-icon-font="&#xe019;"></span>
                                <span className="action-text right share-click">Share</span>
                                <ShareOptions data={data} eleRef={this} />
                            </div>
                        </div>
                    </div>
                </div>
                )}
            </div>
            {sectionData.search_cnt > data.length &&
            <div className="moreResults dev_view_all" onClick={()=>eleRef.getMoreSearchData(sectionData.type)} >SEE MORE RESULTS</div>
            }
        </div>
    );
}
